import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { HYPER_ADDRESS, TOKEN_SYMBOL } from "../utils/constants";

// Register required components for Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const TokenomicsChart = () => {
    // Chart Data
    const data = {
        labels: [
            "Private Sale",
            "Public Sale",
            "Community",
            "Staking",
            "Mining",
            "Marketing",
            "Growth",
        ],
        datasets: [
            {
                data: [18, 27, 5, 15, 10, 15, 10], // Percentage values
                backgroundColor: [
                    "#ff0000",
                    "#fdfd03",
                    "#ffa500",
                    "#00ff3d",
                    "#0014ff",
                    "#ff00de",
                    "#bc00ff",
                ],
                borderColor: "#ffffff",
                borderWidth: 2,
            },
        ],
    };

    // Chart Options
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "30%" as const, // Converts to '30%' in TypeScript
        plugins: {
            tooltip: {
                callbacks: {
                    label: (tooltipItem: any) => {
                        let sum = tooltipItem.dataset.data.reduce((a: number, b: number) => a + b, 0);
                        let value = tooltipItem.raw;
                        let percentage = ((value / sum) * 100).toFixed(1) + "%";
                        return `${percentage} (${(value * 10000000).toLocaleString()} HYPER) `;
                    },
                },
            },
            legend: {
                display: false,
            },
        },
    };

    return (
        <div className="why-choose-us">
            <div className="container">
                <div className="row section-row">
                    {/* Section Title Start */}
                    <div className="section-title">
                        <h3 className="wow fadeInUp">Tokenomics</h3>
                        <h2 className="text-anime-style-2" data-cursor="-opaque">
                            <span>Tokenomics</span> &amp; Infomation
                        </h2>
                    </div>
                    {/* Section Title End */}
                </div>
                <div className="why-choose-us-box">
                    <div className="row no-gutters align-items-center">
                        <div className="col-lg-6">
                            <div className="why-choose-box-1">
                                <div className="why-choose-item wow fadeInUp">
                                    <div className="why-choose-content">
                                        <h6>Name: </h6>
                                        <p>Hyper Stake AI</p>
                                        <hr />
                                        <h6>Symbol: </h6>
                                        <p>{TOKEN_SYMBOL}</p>
                                        <hr />
                                        <h6>Contract: </h6>
                                        <p>{HYPER_ADDRESS}</p>
                                        <hr />
                                        <h6>Total Supply: </h6>
                                        <p>1,000,000,000 {TOKEN_SYMBOL}</p>
                                        <hr />
                                        <h6>Usage: </h6>
                                        <p>
                                            It allows users to stake for passive rewards and easily pay
                                            for AI services.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why-choose-box-2">
                                <div className="why-choose-item wow fadeInUp">
                                    <div className="why-choose-content">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <h6 className="color-red">Private Sale </h6>
                                                <p className="color-red">180,000,000 HYPER</p>
                                                <hr />
                                                <h6 className="color-yellow">Public Sale</h6>
                                                <p className="color-yellow">270,000,000 HYPER</p>
                                                <hr />
                                                <h6 className="color-orange">Community</h6>
                                                <p className="color-orange">50,000,000 HYPER</p>
                                            </div>
                                            <div className="col-md-6">
                                                <h6 className="color-green">Staking</h6>
                                                <p className="color-green">150,000,000 HYPER</p>
                                                <hr />
                                                <h6 className="color-blue">Mining</h6>
                                                <p className="color-blue">100,000,000 HYPER</p>
                                                <hr />
                                                <h6 className="color-violet">Marketing</h6>
                                                <p className="color-violet">150,000,000 HYPER</p>
                                                <hr />
                                                <h6 className="color-indigo">Growth</h6>
                                                <p className="color-indigo">100,000,000 HYPER</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="why-choose-image" style={{ width: "300px", height: "300px" }}>
                                    <Doughnut data={data} options={options} />
                            </div>
                        </div>
                    </div>
                </div>
                {/* Why Choose Us Box End */}
            </div>
        </div>
    );
};

export default TokenomicsChart;
